export default "__VITE_ASSET__DaQyo2uj__"